/**
 * name 时间轴梳理
 * author zhang.yingyu
 * createTime 2019-04-01
 **/
"use strict";
angular.module("timeAxisModule",[])
    .controller("timeAxisCtrl",["$scope","$q","trsHttpService","modalDialog",'$state',function($scope,$q,trsHttpService,modalDialog,$state){
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function  initStatus(){
            $scope.status={
                showHotDetailPanel:[],
                hotSearchType :[
                    {name:"热点名",value:1},
                    {name:"热点内容",value:2},
                    {name:"关键词",value:3},
                    {name:"实体人名",value:4},
                    {name:"实体机构",value:5},
                ],
            };
            $scope.timeAxisParams={
                'modelid':"searchList",
                'serviceid': 'timeline',
                'type':"",
                'search_word':"",
                'search_date':""
            };
            $scope.data={};
            $scope.status.hotSearchTypeSelected = angular.copy($scope.status.hotSearchType[0]);
        };
        /**
         * [initData description]初始化数据
         */
        function initData(){
            getRightTimeAxisList();
        }
        /**
         * [requestData description] 获取数据
         * @return {[type]} [description]
         */
        function requestData(){
            var defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.timeAxisParams, "get").then(function(data) {
                $scope.data.TOTALITEMCOUNT=data.TOTALITEMCOUNT;
                $scope.data.timeAxiSearchList = data.PAGEITEMS;
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [addTimeLine description] 请求加入时间轴
         * @return {[type]} [description]
         */
        function addTimeLine(title,taskid,id){
            var defer=$q.defer();
            var params={
                'modelid':"addTimeLine",
                'serviceid': 'timeline',
                'title':title,
                'taskid':taskid,
                'id':id
            };
            $scope.loadingPromise =trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [addTimeAxis description] 点击加入时间轴
         * @return {[type]} [description]
         */
        $scope.addTimeAxis=function(item,index){
            if($scope.data.timeAxiSearchList[index].FLAG===1) return false;
            addTimeLine(item.TITLE,item.TASKID,item.ID).then(function(data){
                if(!!data){
                    $scope.data.timeAxiSearchList[index].FLAG=1;
                    getRightTimeAxisList();
                }
            });
        };
        /**
         * [getTimeLineList description] 展示加入时间轴的数据
         * @return {[type]} [description]
         */
        function getRightTimeAxisList(){
            var defer=$q.defer();
            var params={
                'modelid':"getTimeLineList",
                'serviceid': 'timeline'
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                $scope.data.rightTimeAxisList=data;
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [deleteRightTimeAxis description] 点击删除时间轴的数据
         * @return {[type]} [description]
         */
        $scope.deleteRightTimeAxis=function(item,index){
            $scope.data.rightTimeAxisList.splice(index,1);
            delTimeLine(item.TASKID,item.ID).then(function(data){});
        };
        /**
         * [delTimeLine description] 删除时间抽数据请求
         * @return {[type]} [description]
         */
        function delTimeLine(taskid,id){
            var defer=$q.defer();
            var params={
                'modelid':"delTimeLine",
                'serviceid': 'timeline',
                'taskid':taskid,
                'id':id,
            };
            $scope.loadingPromise =trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                compareTImeAxisData(taskid);
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [compareTImeAxisData description] 稿件加入创作轴后，右侧取消后，创作轴按钮复原
         * @return {[type]} [description]
         */
        function compareTImeAxisData(taskid){
            for(var i=0,datas= $scope.data.timeAxiSearchList;i<datas.length;i++){
                if(datas[i].TASKID==taskid){
                    $scope.data.timeAxiSearchList[i].FLAG=0;
                    break;
                }
            }
        };
        /**
         * [startAnalysis description] 上传excel
         * @return {[type]} [description]
         */
        function upLoadExcel(){
            var defer=$q.defer();
            var params={
                'modelid':"uploadExcel",
                'serviceid': 'timeline',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),params,"get").then(function(data){
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [startAnalysis description] 开始分析
         * @return {[type]} [description]
         */
        $scope.startAnalysis=function(event){
            upLoadExcel().then(function(){
                $state.go("front.plan.medialaboratory.timeaxisdetail");
            });
        };
        /**
         * [queryByDropdown description] 下拉选择
         */
        $scope.queryByDropdown=function(type,value){};
        /**
         * [getSplitData description] 将字符串按;分割
         */
        $scope.getSplitData=function(value){
            var arr=[];
            if(!!value){
                arr=value.split(";");
            }
            return arr;
        };
        /**
         * [searchWord description] 搜索
         */
        $scope.searchWord=function(){
            $scope.timeAxisParams.search_date=$scope.status.startDate+';'+$scope.status.endDate;
            $scope.timeAxisParams.type=$scope.status.hotSearchTypeSelected.value;
            $scope.timeAxisParams.search_word= $scope.status.searchWord;
            requestData();
        };
    }]);